module.exports = __webpack_public_path__ + "static/img/circle-error-outline.71e6a388.svg";